import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default function NousContacter() {

    const contactInfo = [
        {
            icon: <LocationOnIcon sx={{ fontSize: 30, color: '#000' }} />,
            title: 'Adresse',
            content: '24 Rue du Gouverneur Général Éboué',
            subtitle: '92130 Issy-les-Moulineaux, France'
        },
        {
            type: 'image',
            image: '/assets/images/team.jpg',
            alt: 'Jean & Jérôme'
        },
        {
            icon: <EmailIcon sx={{ fontSize: 30, color: '#000' }} />,
            title: 'Email',
            content: 'j.deservigny@studentlink.fr',
            subtitle: 'Réponse sous 24h'
        }
    ];

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Helmet>
                <title>Contact — Student Link</title>
                <meta name="description" content="Contactez l'équipe Student Link: adresse, email, réponses sous 24h." />
                <link rel="canonical" href="https://studentlink.fr/contact" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'Student Link est-il gratuit pour les étudiants ?',
                                acceptedAnswer: { '@type': 'Answer', text: 'Oui, notre plateforme est entièrement gratuite pour tous les étudiants.' }
                            },
                            {
                                '@type': 'Question',
                                name: "Comment rejoindre le réseau d'entreprises ?",
                                acceptedAnswer: { '@type': 'Answer', text: "Inscrivez vous gratuitement sur notre site." }
                            },
                            {
                                '@type': 'Question',
                                name: 'Délai de réponse ?',
                                acceptedAnswer: { '@type': 'Answer', text: 'Nous répondons à tous les messages sous 24h ouvrées.' }
                            }
                        ]
                    })}
                </script>
            </Helmet>
            <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Contactez-nous
                </Typography>
                <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
                    Une question ? Un projet ? Notre équipe est là pour vous accompagner
                </Typography>
            </Box>

            <Grid container spacing={4} sx={{ mb: 6 }}>
                {contactInfo.map((info, index) => {
                    const isEmail = info.title === 'Email';
                    return (
                        <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                            <Card sx={{
                                textAlign: 'center',
                                p: info.type === 'image' ? 0 : { xs: 2.5, md: isEmail ? 2 : 3 },
                                height: '100%',
                                width: '100%',
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 8,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                display: 'flex',
                                alignItems: 'stretch'
                            }}>
                                {info.type === 'image' ? (
                                    <Box component="img"
                                        src={info.image}
                                        alt={info.alt || ''}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                ) : (
                                    <CardContent sx={{ p: 0, width: '100%', '&:last-child': { pb: 0 }, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: 180 }}>
                                        <Box sx={{ mb: 1.5 }}>
                                            {info.icon}
                                        </Box>
                                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 1 }}>
                                            {info.title}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{ fontWeight: 'medium', mb: 0.5, wordBreak: 'break-word' }}
                                        >
                                            {info.content}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3 }}>
                                            {info.subtitle}
                                        </Typography>
                                    </CardContent>
                                )}
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Card sx={{ p: 4, backgroundColor: '#f8f9fa', borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.04)', border: '1px solid', borderColor: 'divider' }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Questions fréquentes
                        </Typography>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Student Link est-il gratuit pour les étudiants ?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Oui, notre plateforme est entièrement gratuite pour tous les étudiants.
                            </Typography>
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Comment rejoindre le réseau d'entreprises ?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Inscrivez vous gratuitement sur notre site.
                            </Typography>
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Délai de réponse ?
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Nous répondons à tous les messages sous 24h ouvrées.
                            </Typography>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}